<template>
  <div class="row">
    <div class="col-10">
      <div class="position-relative" title="برای افزودن مقدار جدید از کلید Insert کیبور استفاده کنید">
        <input type="text" :id="IdElemnt + '-Input'" @input="ChangeInput(Input1)" @keydown="Test($event)" v-model="Input1" class="form-control InputText position-absolute Input-select-option" />
        <select tabindex="-1" :id="IdElemnt + '-Select'" @change="ChangeInput(Input1)" @keydown.prevent="Test($event)" class="form-control w-100 position-absolute" v-model="Input1">
          <option v-for="item in ListInputOption" :key="item.Id">
            {{ item.OnvanMavaredMasrafVam }}
          </option>
        </select>
        <div id="AltLoading" class="mt-1 position-absolute d-none" style="z-index: 1000; left: 20px; top: 1.5px">
          <small class="spinner-border spinner-border-sm text-warning"></small>
        </div>
        <div id="AltSuccess" class="badge btn-success mt-1 position-absolute d-none" style="z-index: 1000; left: 20px; top: 1.5px">
          <small class="font-weight-normal text-light">ثبت موفق</small>
        </div>
        <div id="AltNotsuccess" class="badge btn-danger mt-1 position-absolute d-none" style="z-index: 1000; left: 20px; top: 3px">
          <small class="font-weight-normal text-light">ثبت ناموفق</small>
        </div>
      </div>
    </div>
    <div v-if="ErrorNum != null" class="col-2 pr-0">
      <div class="badge btn-outline-danger mt-1" :title="TitleError">
        <i class="fa fa-info"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Input1: '',
      TitleError: '',
      ErrorNum: null,
      route: this.$route.name.substring(0, 6) == 'Detail' ? this.$route.name.substring(6) : this.$route.name,
      List: null,
      ModelReturn: { Id: 0, Text: '' },
      ListInputOption:[]
    }
  },
  methods: {
    Test(e) {
      if (e.key == 'Insert') {
        document.getElementById(this.IdElemnt + '-Select').add(new Option(this.Input1))
        let Action = this.$route.name.substring(0, 6) == 'Detail' ? this.$route.name.substring(6) : this.$route.name
        Action = Action + '/' + this.ActionUrl
        let Model = {
          Id: 1,
          OnvanMavaredMasrafVam: this.Input1,
          SharhMavaredMasrafVam: 'CLOUD INSERTED',
          ZamanInsert: this.$store.state.JalaliDateAndTime,
          tblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
          ZamanLastEdit: null,
          TblUserGrpIdLastEdit: null,
          InfoDes: null,
        }
        let DataAxios_SetInputSelect = {
          ArryfildValue: {},
          Method: 'post',
          Action: Action,
          Token: this.$session.get('Token'),
        }
        DataAxios_SetInputSelect.ArryfildValue = Model

        document.getElementById('AltLoading').classList.remove('d-none')
        this.$PostData(DataAxios_SetInputSelect).then((data) => {
          if (data.Status == 'Ok') {
            this.List = data.Data
            // let ac = this.$route.name.substring(0, 6) == 'Detail' ? this.$route.name.substring(6) : this.$route.name

            this.ListInputOption = this.List
            //پیدا کردن آیدی و ساخت مدل و امیت کردن آن
            this.ErrorNum = null
            document.getElementById('AltLoading').classList.add('d-none')
            document.getElementById('AltSuccess').classList.remove('d-none')
            let stop = setInterval(function () {
              document.getElementById('AltSuccess').classList.add('d-none')
              clearInterval(stop)
            }, 2200)
          } else {
            this.ErrorNum = data.eNum
            this.TitleError = data.eNum == 2601 ? 'مورد وارد شده تکراری می باشد' : 'خطای برنامه نویسی'
            document.getElementById('AltLoading').classList.add('d-none')
            document.getElementById('AltNotsuccess').classList.remove('d-none')
            let stop1 = setInterval(function () {
              document.getElementById('AltNotsuccess').classList.add('d-none')
              clearInterval(stop1)
            }, 2200)
          }
        })
      }
    },
    ChangeInput(input) {
      let ac = this.$route.name.substring(0, 6) == 'Detail' ? this.$route.name.substring(6) : this.$route.name
      let List = this.ListInputOption
      if (input != null && input != '') {
        List.forEach((element) => {
          if (element.OnvanMavaredMasrafVam == input) {
            this.ModelReturn.Id = element.Id
            this.ModelReturn.Text = element.OnvanMavaredMasrafVam
            this.$emit('Value_IN_OP', this.ModelReturn)
          }
        })
      }
    },
  },
  created() {
    let Action = this.$route.name.substring(0, 6) == 'Detail' ? this.$route.name.substring(6) : this.$route.name
    Action = Action + '/' + this.ActionUrlGet
    var DataAxios_Get = {
      ArryfildValue: {},
      Method: 'post',
      Action: Action,
      Token: this.$session.get('Token'),
    }
    this.$GetData_Body(DataAxios_Get).then((data) => {
      let ac = this.$route.name.substring(0, 6) == 'Detail' ? this.$route.name.substring(6) : this.$route.name
      this.ListInputOption = data
    })
    if (this.IdEditMode != null && this.IdEditMode != '') {
      let ac = this.$route.name.substring(0, 6) == 'Detail' ? this.$route.name.substring(6) : this.$route.name
      let List = this.ListInputOption
      List.forEach((element) => {
        if (element.Id == this.IdEditMode) {
          this.ModelReturn.Id = element.Id
          this.ModelReturn.Text = element.OnvanMavaredMasrafVam
          this.Input1 = this.ModelReturn.Text
          this.$emit('Value_IN_OP', this.ModelReturn)
        }
      })
    }
  },
  mounted() {},
  updated() {
    this.$emit('Value_IN_OP', this.ModelReturn)
  },
  props: ['IdElemnt', 'ActionUrl', 'ActionUrlGet', 'IdEditMode'],
}
</script>
<style scoped>
.Input-select-option {
  text-align: right;
  height: calc(1.2em + 0.75rem + 2px);
  top: 1px;
  right: 1px;
  border: none;
  direction: ltr;
  z-index: 1000;
  width: 90% !important;
}
.Input-select-option:focus {
  border-color: rgba(228, 228, 228, 0);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0) inset, 0 0 8px rgba(226, 53, 47, 0);
  outline: 0 none;
}
</style>
